import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { ItassetService } from 'src/app/_services/itasset/itasset.service';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';

@Component({
  selector: 'app-it-asset-form',
  templateUrl: './it-asset-form.component.html',
  styleUrls: ['./it-asset-form.component.scss'],
})
export class ItAssetFormComponent implements OnInit {
  tenantId: string;
  currentUser: any;
  rowData: any;
  // modeAction: number = 1; //1 - create // 2 - update
  public columnDefs: ColDef[];
  // gridApi and columnApi
  private api: GridApi;
  private columnApi: ColumnApi;
  itassetForm: FormGroup;
  form: FormGroup;
  selectedCheckboxData = [];
  rowSelection: any;
  defaultColDef: any;
  9;
  deleteConfirmationMsg = 'Are you sure you want to delete';
  userDropdownList = [];
  ItAssetId: any;

  constructor(
    private itassetService: ItassetService,
    private storageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private allocationService: AllocationService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.itassetForm = new FormGroup({
      id: new FormControl(''),
      assetType: new FormControl('', Validators.required),
      assetId: new FormControl('', [ Validators.required, Validators.pattern('^[a-zA-Z0-9 ]*$') ]),
      macId: new FormControl(''),
      user: new FormControl('', Validators.required),
      userId: new FormControl(''),
      department: new FormControl(''),
      model: new FormControl('', [ Validators.required, Validators.pattern('^[a-zA-Z0-9 ]*$') ]),
      sn: new FormControl('', Validators.required),
      pn: new FormControl(''),
      warranty: new FormControl(''),
      installDate: new FormControl('', Validators.required),
      os: new FormControl(''),
      vendor: new FormControl('', Validators.required),
      location: new FormControl(''),
      configuration: new FormControl(''),
      summary: new FormControl(''),
      expiryForRented: new FormControl(''),
      processor: new FormControl(''),
      ram: new FormControl(''),
      harddisk: new FormControl(''),
      display: new FormControl(''),
      keyboard: new FormControl(''),
      mouse: new FormControl(''),
      installationReleaseDate: new FormControl(''),
      rentalCost: new FormControl('', Validators.pattern('^[0-9. ]*$')),
      state: new FormControl(''),
      role: new FormControl(''),
      invoiceNo: new FormControl(''),
      version: new FormControl(''),
      availableQuantity: new FormControl(''),
      graphicsCard: new FormControl(''),
      eligibleSystem: new FormControl('')
    });
  }

  // getter for easy access to form fields
  get f() {
    return this.itassetForm.controls;
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));

    this.ItAssetId = this.route.snapshot.paramMap.get('id');
    console.log('HURRAY I GOT ID ', this.ItAssetId);
    if (this.ItAssetId) this.getItassetById(this.ItAssetId);

    this.getItAssetData();
    this.getUserList();
  }

  getItassetById(id) {
    console.log('HURRAY I IN ASSETBYID ', this.ItAssetId);
    this.itassetService.getItasset(id).subscribe(
      (response) => {
        console.log(response);
        if (response) {
          this.itassetForm.patchValue(response);
          
          if (response.userId){
            this.itassetForm.value.user = this.itassetForm.value.userId +" . "+ this.itassetForm.value.user;
            this.itassetForm.patchValue(this.itassetForm.value);
          }
          
        }
      },
      (error) => {
        console.log('ERROR: cannot get project by id: ' + error);
      }
    );
  }

  getItAssetData() {
    this.itassetService.getAllItasset().subscribe((response: any) => {
      this.rowData = response.result;
    });
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = [];
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data);
    }
  }

  // createItAsset() {
  //   let details = JSON.stringify(this.itassetForm.value);
  //   this.itassetService.createItasset(details).subscribe(response => {
  //     console.log("response: ", response);

  //     // update grid after creating new lead & close the modal
  //     this.api.applyTransaction({ add: [response] });
  //     $('#closeCreateModal').trigger("click");
  //   });
  // }

  createItAsset() {
    console.log('I am in create');
    console.log(this.itassetForm.get('mouse').value);
    console.log(this.itassetForm.get('keyboard').value);
    //let parentId = this.itassetForm.get('parentId').value.split('. ')[0];
    let data = {
      id: this.itassetForm.get('id').value,
      assetType: this.itassetForm.get('assetType').value,
      assetId: this.itassetForm.get('assetId').value,
      macId: this.itassetForm.get('macId').value,
      user: this.itassetForm
        .get('user')
        .value.toString()
        .substring(
          this.itassetForm.get('user').value.toString().indexOf('.') + 1
        )
        .trim(),
      userId: parseInt(this.itassetForm.get('user').value.split(' . ')[0]),
      department: this.itassetForm.get('department').value,
      model: this.itassetForm.get('model').value,
      sn: this.itassetForm.get('sn').value,
      pn: this.itassetForm.get('pn').value,
      warranty: this.itassetForm.get('warranty').value,
      installDate: this.itassetForm.get('installDate').value,
      os: this.itassetForm.get('os').value,
      vendor: this.itassetForm.get('vendor').value,
      location: this.itassetForm.get('location').value,
      configuration: this.itassetForm.get('configuration').value,
      processor: this.itassetForm.get('processor').value,
      ram: this.itassetForm.get('ram').value,
      harddisk: this.itassetForm.get('harddisk').value,
      display: this.itassetForm.get('display').value,
      rentalCost: this.itassetForm.get('rentalCost').value,
      state: this.itassetForm.get('state').value,
      keyboard: this.itassetForm.get('keyboard').value,
      mouse: this.itassetForm.get('mouse').value,
      installationReleaseDate: this.itassetForm.get('installationReleaseDate').value,
      role: this.itassetForm.get('role').value,
      invoiceNo: this.itassetForm.get('invoiceNo').value,
      version: this.itassetForm.get('version').value,
      availableQuantity: this.itassetForm.get('availableQuantity').value,
      graphicsCard: this.itassetForm.get('graphicsCard').value,
      eligibleSystem: this.itassetForm.get('eligibleSystem').value
    };
    console.log(data);
    this.itassetService.createItasset(data).subscribe((response) => {
      this.api.applyTransaction({ add: [response] });
      this.backToItAsset();
    });
  }

  editOpenModal() {
    //this.modeAction = 2;
    console.log('Hit in the edit = ', this.selectedCheckboxData[0].id);
    this.itassetForm.patchValue(this.selectedCheckboxData[0]);
  }

  createOpenModal() {
    //this.modeAction = 1;
    this.itassetForm.patchValue({
      id: '',
      assetType: '',
      assetId: '',
      macId: '',
      user: '',
      department: '',
      model: '',
      sn: '',
      pn: '',
      warranty: '',
      installDate: '',
      os: '',
      vendor: '',
      location: '',
      configuration: '',
      summary: '',
      expiryForRented: '',
      processor: '',
      ram: '',
      harddisk: '',
      display: '',
      rentalCost: '',
      state: false,
      keyboard: false,
      mouse: false,
      installationReleaseDate: '',
      role: '',
      invoiceNo: '',
      version: '',
      availableQuantity: '',
      graphicsCard: '',
      eligibleSystem: ''
    });
  }

  updateItAsset() {
    //console.log(this.selectedCheckboxData[0].id);
    //let id = this.selectedCheckboxData[0].id;
    //let data = this.itassetForm.value;
    let data = {
      id: this.itassetForm.get('id').value,
      assetType: this.itassetForm.get('assetType').value,
      assetId: this.itassetForm.get('assetId').value,
      macId: this.itassetForm.get('macId').value,
      user: this.itassetForm
        .get('user')
        .value.toString()
        .substring(
          this.itassetForm.get('user').value.toString().indexOf('.') + 1
        )
        .trim(),
        userId: parseInt(this.itassetForm.get('user').value.split(' . ')[0]),
        department: this.itassetForm.get('department').value,
        model: this.itassetForm.get('model').value,
        sn: this.itassetForm.get('sn').value,
        pn: this.itassetForm.get('pn').value,
        warranty: this.itassetForm.get('warranty').value,
        installDate: this.itassetForm.get('installDate').value,
        os: this.itassetForm.get('os').value,
        vendor: this.itassetForm.get('vendor').value,
        location: this.itassetForm.get('location').value,
        configuration: this.itassetForm.get('configuration').value,
        processor: this.itassetForm.get('processor').value,
        ram: this.itassetForm.get('ram').value,
        harddisk: this.itassetForm.get('harddisk').value,
        display: this.itassetForm.get('display').value,
        rentalCost: this.itassetForm.get('rentalCost').value,
        state: this.itassetForm.get('state').value,
        keyboard: this.itassetForm.get('keyboard').value,
        mouse: this.itassetForm.get('mouse').value,
        installationReleaseDate: this.itassetForm.get('installationReleaseDate').value,
        role: this.itassetForm.get('role').value,
        invoiceNo: this.itassetForm.get('invoiceNo').value,
        version: this.itassetForm.get('version').value,
        availableQuantity: this.itassetForm.get('availableQuantity').value,
        graphicsCard: this.itassetForm.get('graphicsCard').value,
        eligibleSystem: this.itassetForm.get('eligibleSystem').value
    };
    this.itassetService
      .updateItasset(data, this.ItAssetId)
      .subscribe((res) => {
        this.getItAssetData();
        this.selectedCheckboxData = [];
        this.backToItAsset();
        //$('#closeCreateModal').trigger('click');
      });
  }

  deleteItAssetList() {
    this.itassetService
      .deleteItasset(this.selectedCheckboxData[0].id)
      .subscribe(() => {
        this.getItAssetData();
        this.selectedCheckboxData = [];
        $('#closeModalDeleteItAsset').trigger('click');
      });
  }

  getUserList() {
    this.userDropdownList = [];
    this.allocationService.getUserDetails().subscribe((response) => {
      for (let item of response) {
        this.userDropdownList.push(`${item.id} . ${item.firstName} ${item.lastName}`);
      }
    });
  }

  backToItAsset() {
    this.router.navigate([this.tenantId + '/dashboard/itm/it-asset']);
  }

  cancelButton() {
    this.router.navigate([this.tenantId + '/dashboard/itm/it-asset']);
  }
}
